import cx from 'classnames';
import { BZ_IN_STOCK, WHERE_TO_BUY_ITEM_CTA } from 'mk/autogenerated/translations/ReviewWhereToBuyListItem.ddd7f9464d137916bf68868f3567083d'
import { formatPrice } from 'mk/bazaar/common/formatters';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Link } from 'mk2/components/Link';
import { TrackClick } from 'mk2/components/TrackClick';
import { StoreEventParamsOfSourceContent } from 'mk2/helpers/article_ast/filters';
import React from 'react';
import styles from './ReviewWhereToBuyListItem.mscss';

interface OwnProps {
    eshopUrl: string;
    eshopName: string;
    eshopHint?: string;
    productUrl: string;
    price: number | string;
    inStock?: boolean;
    isLast?: boolean;
    trackClickWithDetails?: StoreEventParamsOfSourceContent;
}

export const ReviewWhereToBuyListItem: React.FunctionComponent<OwnProps> = React.memo(({
    eshopUrl, eshopName, eshopHint, productUrl, price,
    inStock, isLast = false, trackClickWithDetails,
}) => (
    <TrackClick
        name="wiki_review_where_to_buy_item_click"
        props={{product_url: eshopUrl, ...trackClickWithDetails}}
    >
        <div className={cx(styles.ReviewWhereToBuyListItem, !isLast && styles['ReviewWhereToBuyListItem--isNotLast'])}>
            <div className={styles.ReviewWhereToBuyListItem__seller}>
                <Link className={styles.ReviewWhereToBuyListItem__seller} to={eshopUrl}>
                    <span className={styles.ReviewWhereToBuyListItem__seller__name}>{eshopName}</span>
                    {eshopHint &&
                        <span className={styles.ReviewWhereToBuyListItem__seller__hint}>
                            {' '}
                            {eshopHint}
                        </span>
                    }
                </Link>
            </div>
            <div className={styles.ReviewWhereToBuyListItem__price}>
                <div className={styles.ReviewWhereToBuyListItem__price__price}>{price ? formatPrice(price) : '-'}</div>
                {inStock && <div className={styles.ReviewWhereToBuyListItem__price__inStock}>{BZ_IN_STOCK}</div>}
            </div>
            <div className={styles.ReviewWhereToBuyListItem__product}>
                <Btn type={BtnType.Blue} label={WHERE_TO_BUY_ITEM_CTA} link={productUrl} linkTarget="_blank" asAnchor />
            </div>
        </div>
    </TrackClick>
));